import React, { useState } from "react";
import From from "./From/From";
import View from "./View/View";
const Build = () => {
  const [isFromOpen, setIsFromOpen] = useState(false);

  const handleFrom = () => {
    setIsFromOpen(!isFromOpen);
  };

  return (
    <>
      {isFromOpen ? (
        <From onClose={handleFrom} />
      ) : (
        <View onOpen={handleFrom} />
      )}
    </>
  );
};
export default Build;
